/* eslint-disable import/extensions */
import StartedPageCardsItem from './StartedPageCardsItem';
import connectionIcon from '@/assets/images/startPageImages/ikona-polaczenia.png';
import widgetsIcon from '@/assets/images/startPageImages/ikona-widget.png';
import agentsAndNumbersIcon from '@/assets/images//startPageImages/ikona-numery-konsultanci.png';
import departmentsIcon from '@/assets/images//startPageImages/ikona-wirtualne-dzialy.png';
import helpIcon from '@/assets/images/startPageImages/ikona-pomoc.png';
import contactIcon from '@/assets/images/startPageImages/ikona-kontakt.png';
import descriptionsForMenuElements from './descriptionsForMenuElements.json';

// @vue/component
export default {
  name: 'StartedPageCardsLayout',
  components: {
    StartedPageCardsItem,
  },

  data() {
    return {
      connectionIcon,
      widgetsIcon,
      agentsAndNumbersIcon,
      departmentsIcon,
      helpIcon,
      contactIcon,
      descriptionsForMenuElements,
    };
  },

  computed: {
    accessPermissionsDefinitions() {
      return this.$store.getters['authorization/accessPermissionsDefinitions'];
    },
  },
  methods: {
    getDescriptionByName(name) {
      return this.descriptionsForMenuElements.descriptions.filter(value => value.name === name)[0].description;
    },
  },

};
